import { render, staticRenderFns } from "./pinfo.vue?vue&type=template&id=93cd4040&scoped=true&"
import script from "./pinfo.vue?vue&type=script&lang=js&"
export * from "./pinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cd4040",
  null
  
)

export default component.exports